__turbopack_context__.v({
  "className": "handfont_de70700-module__D6zQmq__className",
  "variable": "handfont_de70700-module__D6zQmq__variable",
});
